import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { getAppDataById, putAppData } from "api/AppsApi";
import { postAppData } from "api/AppsApi";
import { toast } from "react-toastify";
import {GET , POST , PUT} from '../../../api/API'

const AppConfigure = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [valueApi, setValueApi] = useState([]);

  const [dataAppConfig, setDataAppConfig] = useState([]);
  const [isConfigured, setIsConfigured] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const history = useHistory();

  const configureApp = () => {
    // check if company app or normal app?
    if (isConfigured) {
      // collect data to be posted
      // put request to server
      console.log("valueApi",valueApi)
      const data = dataAppConfig.map((item) => {
        return {
          id: valueApi?.appConfig?.find((t) => t.metadata?.id === item.metadataId)?.id ,
          value: item.value,
        };
      });

      putAppData(dataApi.id, data)
        .then((data) => {
          toast.success("App configured successfully");
          history.push("/admin/settings/all_apps");
          setIsConfigured(true);
        })
        .catch((error) => {
          toast.error(
            "There was an error in configuring the app. Please try again later."
          );
        });
    } else {
      // collect data to be posted
      // post request to server
      const data = dataAppConfig.map((item) => {
        return {
          metadataId: item.metadataId,
          value: item.value,
        };
      });
      postAppData(dataApi.id, data)
        .then((data) => {
          // setNextButton(Math.floor(response.data.count / 10));
          toast.success("App configured successfully");
          history.push("/admin/settings/all_apps");
          setIsConfigured(true);
        })
        .catch((error) => {
          toast.error("Error in Configuring App");
        });
    }
  };
  useEffect(() => {
    const isConfigured =
      localStorage.getItem("app_isConfigured") === "true" ? true : false;
    const appId = localStorage.getItem("app_id");
    let allowEdit = false
    getAppDataById(appId)
      .then(async (data) => {
        setDataApi(data);
        console.log(data)
        let tempAppConfig = [];
        allowEdit = data.allowEdit 
        isConfigured && !allowEdit  ? setIsSubmit(true) : setIsSubmit(false);

        let capp
        if(isConfigured)
           capp = await GET(`companyApps/${appId}`)
        
           setValueApi(capp)

        console.log("cap",  capp)


        data.metadata &&
          data.metadata.map((meta, idx) => {
            let v = capp?.appConfig?.find((item) => item.metadata?.id === meta.id)?.value
            console.log(v)
            let temp = {
              metadataId: meta.id,
              value:  v || (meta.autogenerated ? meta.autoGeneratedValue : ""),
            };
            tempAppConfig.push(temp);
          });
        setDataAppConfig(tempAppConfig);
      })
      .catch((e) => { })
    setIsConfigured(isConfigured);
    console.log(isConfigured, allowEdit)
    //check if app is already configured and disable the button if it is
  }, []);

  return (
    <div>
      <div>
        <div className="page_heading">
          <h2>App Configuration</h2>
          <button
            className="btn btn-sm"
            style={{ color: "#114169" }}
            onClick={(e) => {
              e.preventDefault();
              props.history.push(`/admin/settings/all_apps`);
            }}
          >{`< Back`}</button>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            configureApp();
          }}
        >
          <div className="audieneOuter">
            <div
              className="inputOuter"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                padding: "2vh",
                width: "70%",
                border: "1px solid rgba(0, 0, 0, 0.125)",
                borderRadius: "15px",
              }}
            >
              <img
                className=" rounded-circle"
                src={
                  dataApi.icon
                    ? dataApi.icon
                    : "https://lasd.lv/public/assets/no-image.png"
                }
                width="36vh"
                alt="app-icon"
              />
              <div>
                <label
                  className="large"
                  style={{
                    marginLeft: "2vh",
                    width: "100%",
                    overflow: "hidden",
                  }}
                >
                  {dataApi.name ? dataApi.name : ""}
                </label>
                <div
                  className="inputOuter"
                  style={{
                    display: "flex",
                    width: "90%",
                    overflow: "hidden",
                    alignItems: "center",
                    marginLeft: "2vh",
                  }}
                >
                  <label className="small">
                    {dataApi.description ? dataApi.description : ""}
                  </label>
                </div>
              </div>
            </div>
            {
              // check for metaadata and map the values to the form fields
              dataApi.metadata &&
              dataApi.metadata.map((obj, index) => {
                return (
                  <>
                    <div className="inputOuter">
                      <label className="large">{obj.label}</label>
                      <input
                        id="audienceName"
                        type={obj.subtype=='password'?  "password":"text"}
                        className="kwDesign max351"
                        required={!obj.autogenerated}
                        disabled={obj.autogenerated}

                        value={
                          dataAppConfig[index]
                            ? dataAppConfig[index].value
                            : ""
                        }
                        onChange={(event) => {
                          let temp = [...dataAppConfig];
                          temp[index].value = event.target.value;
                          setDataAppConfig(temp);
                        }}
                      ></input>
                    </div>
                  </>
                );
              })
            }

            <div className="previewAudience">
              <input
                value="SAVE"
                type="submit"
                disabled={isSubmit}
                className="lg_btn primary"
                style={{
                  backgroundColor: "#2C40CE",
                  // width: "10%",
                  fontFamily: "DM Sans",
                }}
              />
              <a
                href="#"
                // type="reset"
                onClick={() => {
                  history.push("/admin/settings/all_apps");
                }}
                className=" lg_btn tertiary"
                style={{
                  backgroundColor: "#2C40CE",
                  // width: "10%",
                  marginLeft:"10px",
                  fontFamily: "DM Sans",
                }}
              >
                Cancel{" "}
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AppConfigure;
